<template>
  <v-progress-linear
      color="teal darken-4"
      height="10"
      :value="value"/>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Number
    }
  },
  name: "Progressbar"
}
</script>

<style scoped>

</style>
